import { render, staticRenderFns } from "./PaymentSuccessful.vue?vue&type=template&id=52f9b332&"
import script from "./PaymentSuccessful.vue?vue&type=script&lang=js&"
export * from "./PaymentSuccessful.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports